// extracted by mini-css-extract-plugin
export var actions = "_1n-0";
export var actionsContainer = "_1n-7";
export var border = "_1n-1";
export var childFullHeight = "_1n-f";
export var collapse = "_1n-2";
export var content = "_1n-a";
export var contentChild = "_1n-e";
export var fullscreen = "_1n-c";
export var hasLeftRadius = "_1n-k";
export var headerContainer = "_1n-3";
export var headerRow = "_1n-5";
export var hidePadding = "_1n-b";
export var navCollapsedGap = "_1n-l";
export var noScrollX = "_1n-m";
export var noScrollY = "_1n-n";
export var noTopPadding = "_1n-i";
export var optOutTopPadding = "_1n-d";
export var pageMain = "_1n-j";
export var pageOuter = "_1n-g";
export var pagePadding = "_1n-8";
export var pageScroll = "_1n-9";
export var profile = "_1n-o";
export var profileContainer = "_1n-p";
export var profileImage = "_1n-q";
export var profileMain = "_1n-r";
export var profileSubtitle = "_1n-t";
export var profileTitle = "_1n-s";
export var showLeftPadding = "_1n-h";
export var tabsPortalSlot = "_1n-6";
export var tabsWrapper = "_1n-4";
export var title = "_1n-u";